const { dateUtil, helpers } = require("../../utils");
const constants = require("../../constants");

export const getStatusText = (status) => {
  const values = constants.values;
  const { loans } = values;

  if (status === loans.status.PENDING_STATUS_NUMBER) return "Pending";
  if (status === loans.status.REVIEWING_STATUS_NUMBER) return "Review";
  if (status === loans.status.APPROVED_STATUS_NUMBER) return "Approved";
  if (status === loans.status.DENIED_STATUS_NUMBER) return "Denied";

  return "-";
};

export const getStatusStyles = (status) => {
  const style = {
    padding: "1px",
    width: "100px",
    borderRadius: "15px",
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#ccc",
  };

  if (status === constants.values.loans.status.REVIEWING_STATUS_NUMBER) {
    style.backgroundColor = "orange";
  }
  if (status === constants.values.loans.status.APPROVED_STATUS_NUMBER) {
    style.backgroundColor = "#4BB543";
  }
  if (status === constants.values.loans.status.DENIED_STATUS_NUMBER) {
    style.backgroundColor = "red";
  }

  return style;
};

export const columns = [
  {
    title: "Name",
    dataIndex: "personal_details",
    key: "name",
    render: (personal_details) => {
      return (
        <p>
          {personal_details?.first_name} {personal_details?.last_name}
        </p>
      );
    },
  },
  {
    title: "Loan Amount",
    dataIndex: "financial_details",
    key: "loan_amount",
    render: (row) => {
      console.log(row);
      return <p>{helpers.toCurrency(row?.loan_amount)}</p>;
    },
  },
  {
    title: "Loan Status",
    dataIndex: "status",
    key: "status",
    render: (status) => <p>{getStatusText(status)}</p>,
  },
  {
    title: "Approved Amount",
    dataIndex: "approved_amount",
    key: "approved_amount",
    render: (approved_amount) => (
      <p style={{ width: "100px", textAlign: "center" }}>
        {approved_amount ? helpers.toCurrency(approved_amount) : "-"}
      </p>
    ),
  },
  {
    title: "Actions",
    key: "actions",
    render: () => {
      return <button>Click</button>;
    },
  },
];
